import React from 'react';
import { 
  Shield, 
  Target, 
  Zap, 
  Database, 
  Layers3, 
  Workflow 
} from 'lucide-react';
import '../styles/ValueProposition.css';

const ValueProposition = () => {
  const valueProps = [
    {
      icon: Target,
      title: "Earlier Findings, Safer Outcomes",
      description: "Provide care teams with timely, clinically validated insights to enable early interventions, improved outcomes, and control length of stay."
    },
    {
      icon: Zap,
      title: "Reduce Alert Fatigue, Maintain Vigilance", 
      description: "Deliver only high-value signals so teams can act with focus, increasing efficiency without adding workload."
    },
    {
      icon: Layers3,
      title: "Deploy Without Disruption",
      description: "Integrate into current infrastructure for rapid, cost-effective rollout with minimal IT involvement and immediate scalability."
    },
    {
      icon: Database,
      title: "Transform Siloed Data Into Actionable Intelligence",
      description: "Unify healthcare data to power predictive analytics, inform decisions, and drive improvement."
    },
    {
      icon: Shield,
      title: "Enterprise-Grade Security by Design",
      description: "Zero-trust architecture with advanced encryption and granular access controls ensures data integrity and compliance."
    },
    {
      icon: Workflow,
      title: "Built to Integrate, Not Disrupt",
      description: "Works within existing EHR workflows, delivering earlier insights without changing established clinical practices."
    }
  ];

  return (
    <section className="value-proposition">
      <div className="value-container">
        <div className="value-header">
          <h2 className="value-title">Trusted Intelligence for Safer, Smarter Healthcare</h2>
          <h3 className="value-subtitle">We make the health journey proactive, precise and profoundly human</h3>
        </div>
        
        <div className="value-grid">
          {valueProps.map((prop, index) => {
            const IconComponent = prop.icon;
            return (
              <div key={index} className="value-card">
                <div className="value-icon-wrapper">
                  <IconComponent size={40} className="value-icon" />
                </div>
                <div className="value-content">
                  <h3 className="value-card-title">{prop.title}</h3>
                  <p className="value-card-description">{prop.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;